<template>
  <CardGraphicWithBorder
    class="card"
    img-alt="Cadeau"
    img-src="/images/categories/gift-simple.svg"
    :show-controls="true"
    :close-click-outside="true"
  >
    <template #title> {{ $t('content.trialTitle') }} </template>
    <template #description>
      <p>
        {{ $t('content.trial') }}
      </p>
    </template>
    <template #footer>
      <ButtonBase
        :rounded="true"
        theme="secondary"
        stroke="n"
        class="button"
        size="small"
        @click="emit('confirm')"
      >
        Découvrir
      </ButtonBase>
    </template>
  </CardGraphicWithBorder>
</template>

<script setup lang="ts">
interface Props {}

defineProps({
  
});

const emit = defineEmits(["confirm"]);

// const dialog = useDialogStore();
</script>
<style lang="scss" scoped>
.card {
  justify-self: center;
  width: 32rem;
  box-shadow: rgb(0 0 0 / 16%) 0 10px 36px 0, rgb(0 0 0 / 6%) 0 0 0 1px;

  @include above('l') {
    width: 50rem;
  }
}
</style>
